module.exports = __webpack_public_path__ + "static/media/veneto-village-23.f108fc35.jpg";